<template>
  <div>
      <div class="form-check" v-for="(item, index) in list" v-if="showAll || index < 6">

        <template v-if="name === 'type'">
          <input :name="item.taxonomy[item.slug]"
                 type="checkbox"
                 :id="'taxonomy-' + item.taxonomy + '-' + item.slug"
                 :value="item.slug"
                 v-model="activeFilter">
        </template>
        <template v-else>
          <input :name="item.taxonomy[item.slug]"
                 type="checkbox"
                 :id="'taxonomy-' + item.taxonomy + '-' + item.slug"
                 :value="item.name"
                 v-model="activeFilter">
        </template>
        <label :for="'taxonomy-' + item.taxonomy + '-' + item.slug" class="font-weight-normal"><span v-html="item.name"></span></label>
      </div>
      <a @click.prevent="toggle()" class="d-block mt-1" href="#" v-if="list.length > 6" v-html="toggleLabel"></a>
      <a @click.prevent="activateFilter([])" class="d-block mt-1" href="#">{{ clearLabel }}</a>
  </div>
</template>

<script>
  export default {
    name: 'filterlist',
    props: ['list', 'name', 'clearLabel', 'showMoreLabel', 'showLessLabel'],
    computed: {
      isActive() {
        return this.activeFilter.length > 0;
      },
      toggleLabel() {
        return !this.showAll ? this.showMoreLabel : this.showLessLabel;
      }
    },
    watch: {
      activeFilter(filter) {
        this.$emit('filterChanged', encodeURIComponent(this.name), filter)
      }
    },
    created() {

      // Based on URL path get product-tag or product-category
//      if(location.pathname.includes('product')) {

        var segment = location.pathname.split ('/').filter(item => item);

      if(segment.length > 0) {
        let name = segment[0],
            value = segment[1];

        if ('product-category' === name) {
          name = 'categories';
        }
        if ('ledenwinkel-categorie' === name) {
          name = 'categories';
        }
        if ('product-tag' === name) {
          name = 'tags';
        }
        if ('kinds' === name || 'actueel' === name) {
          name = 'kind';
        }
        if (name === this.name) {
            this.list.forEach(taxonomy => {
              if (taxonomy.slug === value) {
                this.activateFilter(taxonomy);
              }
            });
          }
        }
//      }

      if (location.search.length > 0) {
        let stripUrl = location.search.replace('?', '');
        let segments = stripUrl.split('&');

        segments.forEach(segment => {
          let tax = segment.split('=');
          let name = tax[0];
          let value = tax[1];
          if (name.indexOf([]) > -1) {
            name = name.slice(0, -2);
          }
          if (name === this.name) {
            this.list.forEach(taxonomy => {
              if (taxonomy.slug === value) {
                this.activateFilter(taxonomy);
              }
            });
          }
        });
      }
    },
    data() {
      return {
        showAll: false,
        activeFilter: []
      }
    },
    methods: {
      activateFilter(term) {
        if (term.length === 0) {
          this.activeFilter = [];
        } else {
          let filterIndex = this.filterAlreadyExists(term);

          if (filterIndex >= 0) {
            this.activeFilter.splice(filterIndex, 1);
          } else {
            this.activeFilter.push(term.name);
          }
        }
      },

      // Toggle load more/less
      toggle: function () {
        this.showAll = !this.showAll
      },

      filterAlreadyExists(term) {
        let filterExists = -1;
        this.activeFilter.forEach((filterName, index) => {
          if (term.name === filterName) {
            filterExists = index;
          }
        });

        return filterExists;
      },
      isActiveTerm(term) {
        if (!term) {
          return false;
        }
        return this.activeFilter.includes(term.name);
      }
    }
  }
</script>
